import React from "react";
import styled from "styled-components";

// assets
import image1 from "assets/img/backgrounds/dandelionEarth.png";
import image2 from "assets/img/articleheaderimages/catherine-moran-image-mind-wandering.jpg";
import image3 from "assets/img/articleheaderimages/Guardian-article-image.jpg";
import image4 from "assets/img/articleheaderimages/honeygood.jpg";
import image5 from "assets/img/articleheaderimages/due-best-business.png";
import image6 from "assets/img/articleheaderimages/longevity-dividend.jpg";
import image7 from "assets/img/articleheaderimages/media1.png";
import image8 from "assets/img/articleheaderimages/article1.png";
import image9 from "assets/img/articleheaderimages/article2.png";
import image10 from "assets/img/articleheaderimages/article10.jpeg";
import image11 from "assets/img/articleheaderimages/article11.jpeg";
import image12 from "assets/img/articleheaderimages/article12.jpg";

// components
import { Grid } from "@mui/material";
import { Heading4 } from "components/TextStyles";
import {
  ArticlesContainer,
  NewsContainer,
} from "components/styledsections/ResourcesStyledSections";

const Articles = [
  {
    image: image12,
    isPopular: true,
    category: "Equality",
    date: "June 9, 2025",
    title: "Your sons may fare better than your daughters",
    subtitle:
      "A report crafted to explore the systemic barriers in career development and economic outcomes for Australian women as they age.",
    articleURL:
      "https://www.linkedin.com/posts/deborahmyoung_paygap-genderbias-poverty-activity-7337708709709533184-QoGr/?utm_source=share&utm_medium=member_desktop&rcm=ACoAAAAJWAoBKaR1Gc-dgXhVQ0xzsG39h57Ck1U",
  },
  {
    image: image11,
    isPopular: true,
    category: "Happiness",
    date: "May 15, 2025",
    title: "The Science of Happiness: Connection & Community",
    subtitle:
      "Nearly a century of research, from Harvard's longitudinal study to modern psychology labs, points to one truth: Happiness comes from meaningful connection.",
    articleURL:
      "https://www.linkedin.com/pulse/science-happiness-connection-community-grey-matters-ai-5smsc/?trackingId=INdy7TQFwczntXylUPAFBA%3D%3D",
  },
  {
    image: image10,
    isPopular: true,
    category: "Belonging",
    date: "May 8, 2025",
    title: "Likes, Follows, and Friends but do they add up to belonging?",
    subtitle:
      "Twenty-five years ago, Robert Putnam's Bowling Alone warned that in the U.S., where civic participation had historically been strong, social bonds were unravelling,  a trend now echoed globally.",
    articleURL:
      "https://www.linkedin.com/pulse/likes-follows-friends-do-add-up-belonging-grey-matters-ai-6xeoc/?trackingId=%2BPZVQDevpWR%2FvcmzjUxdrg%3D%3D",
  },
  {
    image: image9,
    isPopular: false,
    category: "Ageism",
    date: "September 3, 2024",
    title: "The Unspoken 'ism'",
    subtitle:
      "In an era where diversity and inclusion are at the forefront of societal change, there remains one pervasive prejudice that often goes unchecked: ageism.",
    articleURL:
      "https://www.linkedin.com/pulse/game-two-halves-embracing-second-half-life-ai-claire-canham-agonc/?trackingId=ySlTFsDRSxij1GNw5x3Klg%3D%3D",
  },
  {
    image: image8,
    isPopular: false,
    category: "Longevity",
    date: "August 14, 2024",
    title: "A Game of Two Halves: Embracing the Second Half of Life with AI",
    subtitle:
      "In football, the game is often won or lost in the second half, where experience, strategy, and resilience come to the forefront. The same can be said for life.",
    articleURL:
      "https://www.linkedin.com/pulse/game-two-halves-embracing-second-half-life-ai-claire-canham-agonc/?trackingId=ySlTFsDRSxij1GNw5x3Klg%3D%3D",
  },
  {
    image: image7,
    isPopular: false,
    category: "Retirement",
    date: "August 6, 2024",
    title: "Retirement is Dead: Vive la Différence!",
    subtitle:
      "When do you think you'll retire? At age 65? Maybe younger if you're fortunate, or older if you're not - or maybe you are more fortunate if you dou't retire?",
    articleURL:
      "https://www.linkedin.com/pulse/retirement-dead-vive-la-différence-claire-canham-lsydc/?trackingId=5J%2Bk0HiTr%2FBKoVxlMvOHlA%3D%3D",
  },

  {
    image: image2,
    isPopular: false,
    category: "Health",
    date: "February 10, 2021",
    title:
      "Young and Restless, Old and Focused: Age-Differences in Mind-Wandering",
    subtitle:
      "New research suggests that older adults can be more focused, less impeded by anxiety and less mentally restless than younger adults.",
    articleURL:
      "https://www.tcd.ie/news_events/articles/young-and-restless-old-and-focused-age-differences-in-mind-wandering/",
  },
  {
    image: image6,
    isPopular: false,
    category: "Longevity",
    date: "July 20, 2023",
    title: "Longevity Dividend Magazine",
    subtitle: "The economics of healthier, longer and more productive lives",
    articleURL: "https://profandrewjscott.com/elementor-4195/",
  },
  {
    image: image3,
    isPopular: false,
    category: "Health",
    date: "September 25, 2018",
    title: "Loneliness among over-50s 'is looming public health concern'",
    subtitle:
      "Greater numbers will feel impact of widowhood, poor finance and ill-health, says Age UK.",
    articleURL:
      "https://www.theguardian.com/society/2018/sep/25/loneliness-among-over-50s-is-looming-public-health-concern",
  },
  {
    image: image4,
    isPopular: false,
    category: "Social",
    date: "November 19, 2023",
    title: "Feeling lonely and invisible as a woman over 50?",
    subtitle:
      "Many women over 50 report feeling lonely and invisible. After a couple of years of pondering, I’ve found some common threads as to why.",
    articleURL: "https://www.honeygood.com/why-women-feel-invisible-after-50/",
  },
  {
    image: image5,
    isPopular: false,
    category: "Diversity",
    date: "May 10, 2023",
    title: "The 9 Best Businesses to Start Over 60",
    subtitle:
      "For those with the itch, starting a business over the age of 60 is entirely doable. Age can give many advantages, including experience and wisdom.",
    articleURL: "https://due.com/best-business-to-start-over-60/",
  },
];

const News = [
  {
    image: image1,
    isTrending: true,
    title: "The rise of organ-on-chip and genome editing",
  },
  {
    image: image1,
    isTrending: true,
    title: "Tokenisation plan to save costs in Australian financial markets",
  },
];

export default function Media() {
  return (
    <>
      <Wrapper className="container">
        <Grid container columnSpacing={4}>
          <Grid item xs={12} lg={8}>
            <VerticalSectionWrapper>
              <Heading4>Articles</Heading4>
              <Grid
                container
                bgcolor="transparent"
                spacing={4}
                justifyContent="flex-start"
                width="auto"
              >
                {Articles.map((article, index) => (
                  <Grid item xs={12} sm={6} key={index}>
                    <ArticlesContainer
                      image={article.image}
                      isPopular={article.isPopular}
                      category={article.category}
                      date={article.date}
                      title={article.title}
                      subtitle={article.subtitle}
                      articleURL={article.articleURL}
                    />
                  </Grid>
                ))}
              </Grid>
            </VerticalSectionWrapper>
          </Grid>
          <Grid item xs={12} lg={4}>
            <VerticalSectionWrapper>
              <Heading4>Latest News</Heading4>
              <Grid
                container
                bgcolor="transparent"
                spacing={4}
                justifyContent="flex-start"
                width="auto"
              >
                {News.map((article, index) => (
                  <Grid item xs={12} sm={6} lg={12} key={index}>
                    <NewsContainer
                      image={article.image}
                      isTrending={article.isTrending}
                      title={article.title}
                    />
                  </Grid>
                ))}
              </Grid>
            </VerticalSectionWrapper>
          </Grid>
        </Grid>
      </Wrapper>
    </>
  );
}

const Wrapper = styled.section`
  display: flex;
`;

const VerticalSectionWrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 48px;
  padding-top: 85px;
  padding-bottom: 65px;
`;
